'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdContentCut = function MdContentCut(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.6 5h5v1.6l-11.6 11.8-3.4-3.4z m-11.6 15.9c0.5 0 0.9-0.4 0.9-0.9s-0.4-0.9-0.9-0.9-0.9 0.4-0.9 0.9 0.4 0.9 0.9 0.9z m-10 12.5c1.8 0 3.4-1.5 3.4-3.4s-1.6-3.4-3.4-3.4-3.4 1.5-3.4 3.4 1.6 3.4 3.4 3.4z m0-20c1.8 0 3.4-1.5 3.4-3.4s-1.6-3.4-3.4-3.4-3.4 1.5-3.4 3.4 1.6 3.4 3.4 3.4z m6.1-0.7l20.5 20.7v1.6h-5l-11.6-11.6-3.9 3.9c0.4 0.8 0.5 1.7 0.5 2.7 0 3.7-2.9 6.6-6.6 6.6s-6.6-2.9-6.6-6.6 2.9-6.6 6.6-6.6c1 0 1.9 0.1 2.7 0.5l3.9-3.9-3.9-3.9c-0.8 0.4-1.7 0.5-2.7 0.5-3.7 0-6.6-2.9-6.6-6.6s2.9-6.6 6.6-6.6 6.6 2.9 6.6 6.6c0 1-0.1 1.9-0.5 2.7z' })
        )
    );
};

exports.default = MdContentCut;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/content-cut.js
// module id = 1392
// module chunks = 168707334958949